import { Injectable } from '@angular/core';
import { StateDispatcher, StateOrchestrator } from 'microedge-rxstate/dist';
import { SkyLinkRecordsStateAction } from './link-records-state-action.type';


export class SkyLinkRecordsStateDispatcher extends StateDispatcher<SkyLinkRecordsStateAction> {
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

export class SkyLinkRecordsStateOrchestrator<T>
  extends StateOrchestrator<T, SkyLinkRecordsStateAction> {
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
